<script lang="ts">
  import { slide } from "svelte/transition";
  import { createEventDispatcher } from "svelte";
  import Icon from "$lib/atoms/Icon.svelte";
  import { IconType } from "$types/atoms";

  const dispatch = createEventDispatcher<{
    click: { index: number };
    mouseenter: { index: number };
    mouseleave: { index: number };
  }>();

  export let active = false;
  export let index: number;

  const toggle = () => {
    dispatch("click", { index });
  };

  function hoverIn() {
    dispatch("mouseenter", { index });
  }

  function hoverOut() {
    dispatch("mouseleave", { index });
  }
</script>

<div
  class={`accordion-item ${active ? "is-active" : ""}`}
  tabindex="-1"
  role="menuitem"
  on:click={toggle}
  on:keydown={toggle}
  on:mouseenter={hoverIn}
  on:mouseleave={hoverOut}
>
  <div class="header">
    <slot name="header" />
    <div class="icon">
      <Icon type={IconType.CHEVRON_DOWN} />
    </div>
  </div>

  {#if active}
    <div class="accordion-inner" transition:slide={{ duration: 300 }}>
      <slot name="body" />
    </div>
  {/if}
</div>

<style lang="scss">
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: fluid(24px, 24px) fluid(24px, 24px) 0 0;
    box-sizing: border-box;
    position: relative;

    @include breakpoint("small") {
      padding: 32px fluid(24px, 24px) 0 0;
    }
  }

  .accordion-item {
    padding: 0 0 fluid(40px, 24px);
    cursor: pointer;
  }

  .icon {
    transition: transform 0.3s;
  }

  .is-active {
    cursor: default;

    .icon {
      transform: rotateZ(-180deg);
    }
  }
</style>
